<div class="modal-header">
  <h5 class="pt-4" style="padding-left:2rem">{{ "Insumos para " + data.material.name }}</h5>
  <button type="button" class="btn-close me-4" (click)="this.close(false)"></button>
</div>
<mat-divider></mat-divider>
<mat-progress-bar *ngIf="loading" mode="indeterminate" color="primary"></mat-progress-bar>
<mat-dialog-content *ngIf="!loading">
  <div class="modal-body mb-4">
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Lista de insumos</mat-label>
          <mat-select [(ngModel)]="selected">
            <mat-option *ngFor="let x of allcomponents; let i = index" [value]="i">
              {{ x.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-auto">
        <button mat-icon-button color="accent" matTooltip="Añadir" [matTooltipPosition]="'above'" class="add-button" [disabled]="selected === -1" (click)="addComponent()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="row align-items-center">
      <table mat-table [dataSource]="matcomponents" class="mat-elevation-z2 w-100">
        <ng-container matColumnDef="component">
          <th mat-header-cell *matHeaderCellDef>Insumo</th>
          <td mat-cell *matCellDef="let x">{{ x.name }}</td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef class="nonmaincol">Cantidad</th>
          <td mat-cell *matCellDef="let x">
            <mat-form-field appearance="outline" class="inputbox">
              <input type="number" matInput min="1" step="1" required [(ngModel)]="x.qty">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="nonmaincol"></th>
          <td mat-cell *matCellDef="let x; let i = index">
            <button mat-icon-button color="warn" type="button" (click)="removeComponent(i)" matTooltip="Quitar insumo" [matTooltipPosition]="'above'">
              <mat-icon>close</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let x; columns: columns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="columns.length" style="text-align: center; padding: 16px;">
            El material no tiene insumos.
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="modal-footer mt-4">
    <button mat-flat-button class="bg-success text-white ms-5" (click)="setData()" [disabled]="!(modified && valid)" type="button">
      Guardar <mat-icon>save</mat-icon>
    </button>
  </div>
</mat-dialog-content>